export const UNCOMMITTED = 0
export const WAITING_FOR_APPROVAL = 1
export const APPROVED = 2
export const REJECTED = 3
